class mCancelOrder extends window.HTMLFormElement {
    constructor() {
        super();
        this.cancelButton = this.querySelector('button');
        this.error = this.querySelector('.error');
        this.remainingTime = this.dataset.remainingTime && parseInt(this.dataset.remainingTime, 10);
        this.cancelOrder = this.cancelOrder.bind(this);
    }

    connectedCallback() {
        this.addEventListener('submit', this.cancelOrder);
        setTimeout(() => {
            this.cancelButton.disabled = true;
        }, this.remainingTime);
    }

    cancelOrder(e) {
        e.preventDefault();
        this.error.innerHTML = '';
        this.cancelButton.disabled = true;
        fetch(this.action, {
            method: 'POST',
            body: new FormData(this),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => {
            return response.json();
        }).then((responseData) => {
            if (responseData.success) {
                window.location.reload();
            } else {
                this.cancelButton.disabled = false;
                this.error.innerHTML = responseData.msg;
            }
        });
    }
}

customElements.define('m-cancel-order', mCancelOrder, {
    extends: 'form'
});
